/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Empty_Invite_BodyInputs */

const en_us2_clubs_empty_invite_body = /** @type {(inputs: Clubs_Empty_Invite_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A club of one is a diary. Bring someone in and the round becomes a challenge.`)
};

const pt_br2_clubs_empty_invite_body = /** @type {(inputs: Clubs_Empty_Invite_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um clube só com você é um diário. Chame alguém e a rodada vira desafio.`)
};

const es_419_clubs_empty_invite_body = /** @type {(inputs: Clubs_Empty_Invite_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un club de una persona es un diario. Suma a alguien y la ronda se vuelve un desafío.`)
};

const pt_pt2_clubs_empty_invite_body = /** @type {(inputs: Clubs_Empty_Invite_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um clube só contigo é um diário. Traz alguém e a ronda passa a ser um desafio.`)
};

const fr_fr2_clubs_empty_invite_body = /** @type {(inputs: Clubs_Empty_Invite_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un club d'une personne, c'est un journal. Fais venir quelqu'un et la manche devient un défi.`)
};

const de_de2_clubs_empty_invite_body = /** @type {(inputs: Clubs_Empty_Invite_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Club mit einer Person ist ein Tagebuch. Hol jemanden dazu, und die Runde wird zur Challenge.`)
};

const it_it2_clubs_empty_invite_body = /** @type {(inputs: Clubs_Empty_Invite_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un club da solo è un diario. Porta qualcuno e il turno diventa una sfida.`)
};

/**
* | output |
* | --- |
* | "A club of one is a diary. Bring someone in and the round becomes a challenge." |
*
* @param {Clubs_Empty_Invite_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_empty_invite_body = /** @type {((inputs?: Clubs_Empty_Invite_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Empty_Invite_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_empty_invite_body(inputs)
	if (locale === "es-419") return es_419_clubs_empty_invite_body(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_empty_invite_body(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_empty_invite_body(inputs)
	if (locale === "de-DE") return de_de2_clubs_empty_invite_body(inputs)
	if (locale === "it-IT") return it_it2_clubs_empty_invite_body(inputs)
	return en_us2_clubs_empty_invite_body(inputs)
});
export { clubs_empty_invite_body as "clubs.empty_invite_body" }